import { render, staticRenderFns } from "./AddAssistantSection.vue?vue&type=template&id=34daf138&scoped=true"
import script from "./AddAssistantSection.vue?vue&type=script&lang=js"
export * from "./AddAssistantSection.vue?vue&type=script&lang=js"
import style0 from "./AddAssistantSection.vue?vue&type=style&index=0&id=34daf138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34daf138",
  null
  
)

export default component.exports